const DIAMETER = [
  [0.12, 0.15, 0.18, 0.48, 0.48, 1.4, 3.6, 4.8],
  [0.15, 0.19, 0.22, 0.6, 0.6, 1.8, 4.5, 6],
  [0.18, 0.24, 0.28, 0.75, 0.75, 2.2, 5.5, 7.5],
  [0.24, 0.3, 0.36, 0.96, 0.95, 2.8, 7, 9.5],
  [0.48, 0.36, 0.45, 1.2, 1.2, 3.4, 9, 11.5],
  [0.96, 0.42, 0.5, 1.3, 1.3, 3.8, 11, 13.5],
  [1.28, 0.48, 0.57, 1.5, 1.5, 4.3, 13, 16],
  [1.64, 0.54, 0.64, 1.7, 1.7, 4.8, 15, 19]
]

const DIAMETER_RANGE = {
  byDWire: [0.36, 0.7, 1.6, 3.4, 7, 14, 28],
  byIndex: [5.1, 6.3, 8.1, 10.1, 12.1, 14.1, 18.1]
}

// Для типов "Растяжения", "Сжатия", "Кручения", "Торсионные"

const DIAMETER_TYPE1238 = [
  [0.2, 0.2, 0.2, 0.24, 0.475, 0.7, 1.8, 2.4],
  [0.2, 0.25, 0.2, 0.3, 0.6, 0.9, 2.25, 3],
  [0.2, 0.25, 0.3, 0.375, 0.75, 1.1, 2.75, 3.75],
  [0.24, 0.3, 0.36, 0.48, 0.95, 1.4, 3.5, 4.75],
  [0.3, 0.4, 0.4, 0.6, 1.2, 1.7, 4.5, 5.75],
  [0.3, 0.4, 0.45, 0.65, 1.3, 1.9, 5.5, 6.75],
  [0.3, 0.4, 0.5, 0.75, 1.6, 2.15, 6.5, 8],
  [0.3, 0.4, 0.5, 1.5, 3.2, 4.3, 13, 16],
  [0.3, 0.4, 0.65, 1.7, 3.6, 4.8, 15, 19],
  [0.3, 0.4, 0.7, 2.5, 4.2, 6, 18, 30]
]

const DIAMETER_RANGE_TYPE1238 = {
  byDWire: [0.36, 0.7, 1.6, 3.1, 7, 14, 28],
  byIndex: [5.01, 6.31, 8.01, 10.01, 12.01, 14.01, 15.01, 18.01, 20.01]
}

export {
  DIAMETER,
  DIAMETER_RANGE,
  DIAMETER_TYPE1238,
  DIAMETER_RANGE_TYPE1238
}
